import React, { Component } from 'react';
import './style.scss';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { getPartner } from '../../service/partners/selector';
import PartnerContainer from '../PartnerContainer';
import { deepEqual } from '../../utils';
import Config from '../../Components/Config';
import { getData } from '../../service/partnersData/actions';
import ExternalIdAssignation from '../../Components/ExternalDataAssignation';
import { Button } from '@material-ui/core';
import PmsVariableServer from '../../Components/PmsVariableServer';

class Thais extends Component {
	shouldComponentUpdate(nextProps) {
		if (
			deepEqual(this.props.partnerData, nextProps.partnerData) &&
			deepEqual(this.props.externalData, nextProps.externalData) &&
			deepEqual(this.props.products, nextProps.products)
		) {
			return false;
		}

		return true;
	}

	componentDidMount() {
		if (this.props.partnerData.length === 0) {
			this.props.getPartnerData();
		}
	}

	render() {
		const { partner, partnerData } = this.props;

		return (
			<PartnerContainer
				name={I18n.t(`partner.prefix.${partner.prefix}`)}
				id={partner ? partner.id : null}
				prefix={partner ? partner.prefix : null}>
				<Button
					style={{ margin: 10 }}
					variant="contained"
					color="primary"
					onClick={this.props.getPartnerData}>
					{I18n.t('general.refresh_data')}
				</Button>

				{partnerData && partnerData.length ? (
					<>
						<h2>{I18n.t('partner.mewsSystems.settingsProductTypes')}</h2>
						<ExternalIdAssignation
							prefix={partner.prefix}
							type="productType"
							externals={partnerData.map(a => ({ id: a.id, name: a.label }))}
						/>
					</>
				) : (
					''
				)}

				<Config prefix_partner={partner.prefix || ''} />
			</PartnerContainer>
		);
	}
}

const mapStateToProps = (state, props) => {
	const partner = getPartner(state, props);
	const data = state.partnersData['thais'] || [];
	const externalData = state.externalData['thais'] || [];

	return {
		partner,
		partnerData: data,
		externalData,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		getPartnerData: _ => dispatch(getData('thais')),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Thais);
